import { lazy, useMemo, Suspense, useEffect } from "react";
import { LoadingSpinner } from "./reusable/LoadingSpinner";
import PreventBackNavigation from "./reusable/PreventBackNavigation";
import { useQuoteController } from "../contexts/QuoteControllerContext";
import { InstallationSwitcher } from "./InstallationSwitcher";
import QuoterError from "./reusable/QuoteError";
import { LLMContextProvider } from "../contexts/LLMContext";
import { BackButtonContextProvider } from "../contexts/BackButtonContext";
import { useHistory } from "react-router-dom";
import { ProgressBarContextProvider } from "../contexts/ProgressBarContext";

const TapolyV2 = lazy(() => import("./installations/TapolyV2"));
const TapolyAI = lazy(() => import("./installations/TapolyAI"));
const TapolyAIDemo = lazy(() => import("./installations/TapolyAIDemo"));

const Home = () => {
    const { isLoading, branding, quoteInProgress, quoteErrors, pageState } =
        useQuoteController();

    //React-Router
    const history = useHistory();

    //Navigate to Correct page when path in pageState changes
    useEffect(() => {
        if (pageState) history.push(pageState.url);
    }, [pageState, history]);

    const contentToRender = useMemo(() => {
        if (quoteInProgress && quoteInProgress.isBrokerQuote)
            return <TapolyV2 />

        switch (branding?.installation) {
            case "Tapoly":
                return <TapolyV2 />
            case "Tapoly-AI":
                return (
                    <LLMContextProvider>
                        <ProgressBarContextProvider>
                            <TapolyAI />
                        </ProgressBarContextProvider>
                    </LLMContextProvider>
                )
            case "Tapoly-AI-Demo":
                return (
                    <LLMContextProvider>
                        <ProgressBarContextProvider>
                            <TapolyAIDemo />
                        </ProgressBarContextProvider>
                    </LLMContextProvider>
                )
            default:
                return null;
        }
    }, [quoteInProgress, branding?.installation]);

    if (quoteErrors && quoteErrors.length > 0)
        return <QuoterError errors={quoteErrors} />;

    return (
        <>
            <PreventBackNavigation />
            {isLoading && <LoadingSpinner />}
            <Suspense fallback={<LoadingSpinner />}>
                {contentToRender}
            </Suspense>
        </>
    )
};

export default Home;
